import { render, staticRenderFns } from "./checkNotificationMail.vue?vue&type=template&id=dcbd02c4&scoped=true&"
import script from "./checkNotificationMail.vue?vue&type=script&lang=js&"
export * from "./checkNotificationMail.vue?vue&type=script&lang=js&"
import style0 from "./checkNotificationMail.vue?vue&type=style&index=0&id=dcbd02c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbd02c4",
  null
  
)

export default component.exports